import Header from '@/components/Header'
import Footer from '@/components/Footer'
import aaronImage from '@/assets/images/about/aaron.jpg'

export default function About() {
  return (
    <>
      <Header currentPage="about" />

      {/* About Header */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            ABOUT US
          </h1>
        </div>
      </section>

      {/* Main About Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto space-y-8">
            
            {/* Company Description */}
            <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
              <p>
                Since 2002, <strong>TAKT Construction Services Ltd.</strong> has been committed to delivering excellence in every project. With a specialization in precast concrete installation, custom architectural concrete formwork, structural concrete seismic upgrades, hardscapes, and home renovations, we take pride in offering a comprehensive suite of construction solutions.
              </p>
              
              <p>
                Our portfolio features diverse projects, from exclusive concrete installations in city parks and outdoor spaces to complex commercial sites. Each project reflects our dedication to quality craftsmanship and attention to detail.
              </p>
              
              <p>
                In addition to our specialized formwork and concrete expertise, we provide a wide range of consultation, technical support, and general contracting services tailored to meet our clients' unique requirements. At TAKT Construction Services Ltd., we don't just build structures; we build trust, lasting relationships, and a reputation for excellence.
              </p>
            </div>

            {/* Owner Section */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center py-12">
              
              {/* Owner Photo */}
              <div className="order-2 lg:order-1">
                <div className="bg-gray-100 rounded-lg overflow-hidden shadow-lg">
                  <img 
                    src={aaronImage} 
                    alt="Aaron Gildener - President of TAKT Construction Services Ltd." 
                    className="w-full h-96 object-cover"
                  />
                </div>
              </div>

              {/* Owner Information */}
              <div className="order-1 lg:order-2 space-y-6">
                                <h2 className="text-3xl font-bold text-gray-900">
                  MEET THE OWNER
                </h2>
                <div className="space-y-4 text-gray-600 leading-relaxed">
                  <p>
                    <strong>Aaron Gildener</strong>, the President of TAKT Construction Services Ltd., brings decades of industry expertise and a passion for delivering exceptional results.
                  </p>
                  <p>
                    His dedication to quality craftsmanship, innovation, and building strong client relationships has been the cornerstone of the company's success. Aaron believes in leading by example, ensuring every project upholds the highest standards of professionalism and integrity.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </>
  )
} 